"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OutputPin = exports.InputPin = exports.WorkflowType = void 0;
__exportStar(require("./types/ArrivalWorkflow"), exports);
__exportStar(require("./types/CancellationWorkflow"), exports);
__exportStar(require("./types/DeclineWorkflow"), exports);
__exportStar(require("./types/EventCancellation"), exports);
__exportStar(require("./types/InvitationWorkflow"), exports);
__exportStar(require("./types/MultiRegistrationWorkflow"), exports);
__exportStar(require("./types/PaymentWaitinglistWorkflow"), exports);
__exportStar(require("./types/PaymentWorkflow"), exports);
__exportStar(require("./types/PreArrivalWorkflow"), exports);
__exportStar(require("./types/ProfileWorkflow"), exports);
__exportStar(require("./types/PublicRegistrationAndMembershipWorkflow"), exports);
__exportStar(require("./types/PublicRegistrationWorkflow"), exports);
__exportStar(require("./types/RegistrationWaitinglistWorkflow"), exports);
__exportStar(require("./types/RegistrationWorkflow"), exports);
__exportStar(require("./types/StageActionWorkflow"), exports);
__exportStar(require("./types/WaitinglistWorkflow"), exports);
__exportStar(require("./types/SplitterWorkflow"), exports);
var WorkflowType;
(function (WorkflowType) {
    WorkflowType["INVITATION"] = "invitation-workflow";
    WorkflowType["REGISTRATION"] = "registration-workflow";
    WorkflowType["PUBLIC_REGISTRATION"] = "public-registration-workflow";
    WorkflowType["PRE_ARRIVAL"] = "pre-arrival-workflow";
    WorkflowType["ARRIVAL"] = "arrival-workflow";
    WorkflowType["CANCELLATION"] = "cancellation-workflow";
    WorkflowType["DECLINE"] = "decline-workflow";
    WorkflowType["PAYMENT"] = "payment-workflow";
    WorkflowType["EVENT_CANCELLATION"] = "event-cancellation-workflow";
    WorkflowType["STAGE_ACTION"] = "stage-action-workflow";
    WorkflowType["PROFILE"] = "profile-workflow";
    WorkflowType["REGISTRAION_WAITINGLIST"] = "registration-waitinglist-workflow";
    WorkflowType["MULTI_REGISTRATION"] = "multi-registration-workflow";
    WorkflowType["PAYMENT_WAITINGLIST"] = "payment-waitinglist-workflow";
    WorkflowType["SPLITTER"] = "splitter-workflow";
})(WorkflowType || (exports.WorkflowType = WorkflowType = {}));
var InputPin;
(function (InputPin) {
    InputPin["INPUT"] = "input";
    InputPin["CANCELLATION_INPUT"] = "cancellation-input";
    InputPin["DECLINE_INPUT"] = "decline-input";
})(InputPin || (exports.InputPin = InputPin = {}));
var OutputPin;
(function (OutputPin) {
    OutputPin["OUTPUT"] = "output";
    OutputPin["CANCELLATION_OUTPUT"] = "cancellation-output";
    OutputPin["DECLINE_OUTPUT"] = "decline-output";
    OutputPin["NEW_CONTACT"] = "new-contact";
    OutputPin["INVITED_CONTACT"] = "invited-contact";
    OutputPin["EXISTING_CONTACT"] = "existing-contact";
    OutputPin["SPLITTER_OUTPUT1"] = "splitter-output1";
    OutputPin["SPLITTER_OUTPUT2"] = "splitter-output2";
})(OutputPin || (exports.OutputPin = OutputPin = {}));
